import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIdCard } from '@fortawesome/pro-regular-svg-icons/faIdCard';

import { Link } from '../../components';

export const Failed = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div>
      <div className='font-bold text-xl mb-5'><FontAwesomeIcon icon={faIdCard} /> {t('identityCheck.failedAll.description')}</div>
      <div className='mb-4 mt-4'>
        <Link
          className='hover:text-sapphire-300 text-sapphire font-bold'
          to={`mailto:${t('common.supportEmail')}`}
          title='Contact Support'
          newTab
          external
        >
          {t('identityCheck.failedAll.contact')}
        </Link>
      </div>
    </div>
  );
};
